export default "__VITE_ASSET__Djtwx4L___"